export const TOAST_DEFAULT_DURATION = 5000;
